import { createContext, useContext } from "react"
import type { TSubscription, TSubscriptionMember } from "../types"

type TSubscriptionContextAdmin = {
  role: "admin"
  subscription: TSubscription
  isReadOnly: boolean
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

type TSubscriptionContextMember = {
  role: "member"
  subscription: TSubscriptionMember
  isReadOnly: boolean
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export type TSubscriptionContext =
  | TSubscriptionContextAdmin
  | TSubscriptionContextMember

export const SubscriptionContext = createContext<TSubscriptionContext | null>(null)

export const useSubscription = (): TSubscriptionContext => {
  const ctx = useContext(SubscriptionContext)
  if (!ctx) {
    throw new Error("useSubscription must be used inside SubscriptionProvider")
  }
  return ctx
}
